function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import Backbone from '@polleverywhere/backbone';
import BEM from '../../../../lib/mixins/_bem';
import Oauth2Redirect from '../oauth2_redirect';
import tmpl from '../../templates/sso/provider.hamlc'; // eslint-disable-line import/no-webpack-loader-syntax

var Provider = /*#__PURE__*/function (_Backbone$View) {
  _inheritsLoose(Provider, _Backbone$View);

  function Provider() {
    return _Backbone$View.apply(this, arguments) || this;
  }

  var _proto = Provider.prototype;
  /**
  * @param {Object} options Configuration options.
  * @param {String} options.name Name of sso service provider
  * @param {String} options.icon Provider icon xml (typically svg, but could be html)
  * @param {String} options.label String that is written on the sign in button
  * @param {Function} options.callbackFn (Oauth2Redirect) -> {} Function called when signin button clicked
  */

  _proto.initialize = function initialize(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    _.extend(this, BEM(this));

    var requiredOptions = ['name', 'icon', 'label', 'callbackFn'];
    requiredOptions.forEach(function (key) {
      if (!options[key]) {
        throw new Error("options." + key + " is required");
      }
    });
    this.name = options.name;
    this.icon = options.icon;
    this.label = options.label;
    var oauth2Redirect = new Oauth2Redirect();
    oauth2Redirect.provider = this.name;

    this.handleSignIn = function () {
      return Promise.resolve(options.callbackFn(oauth2Redirect))["catch"](function (err) {
        return _this.trigger('error', err);
      });
    };
  };

  _proto.render = function render() {
    _Backbone$View.prototype.render.call(this);

    this.$el.html(this.template);
    this.$_toggleModifier(null, this.className, this.name, true);
    this.$_element('icon').html(this.icon);
    this.$_element('label').text(this.label);
    this.trigger('view:action', 'view:oauth_signin', {
      provider: this.name
    });
    return this;
  };

  _createClass(Provider, [{
    key: "template",
    get: function get() {
      return tmpl;
    }
  }, {
    key: "className",
    get: function get() {
      return 'component-auth__sso-providers__provider';
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'button';
    }
  }, {
    key: "events",
    get: function get() {
      var _this2 = this;

      return {
        click: function click() {
          _this2.trigger('view:action', 'click:oauth_signin', {
            provider: _this2.name
          }, {
            immediate: true
          });

          return _this2.handleSignIn();
        }
      };
    }
  }]);

  return Provider;
}(Backbone.View);

export { Provider as default };